import { GetAppFunctionPermissionDetailResponse, GetUserDetailResponse } from '@esg/business-account';
import { SettingAdvanceGetDetailResponse } from '@esg/business-setting/api/advance/enums/settingAdvanceEnums';
import { genericAtom } from './jotai';
export interface LocaleState {
    readonly currency?: string;
    readonly language?: string;
    readonly timezone?: string;
    readonly country?: string;
    readonly format?: string;
    readonly countryCode?: string;
    readonly taxCode?: string;
    readonly members?: GetUserDetailResponse[];
    readonly appFunctionPermissions?: GetAppFunctionPermissionDetailResponse[];
    readonly settingAdvances?: SettingAdvanceGetDetailResponse[];
    readonly contact?: Contact;
}

interface Contact {
    readonly logo?: string;
    readonly phoneNumber?: string,
    readonly name?: string;
    readonly address?: string;
}

const localeDefault: LocaleState = {
    currency: 'USD',
    language: 'en',
    timezone: 'America/New_York',
    country: 'US',
    format: 'MMM DD, YYYY'
};

export const currentLocaleState = genericAtom<LocaleState | null>(
    localeDefault,
);

